import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Mounted once near the top of the app tree (inside <BrowserRouter>).
 * Watches pathname and resets the window scroll to the top on every
 * route change so every page starts at the top instead of inheriting
 * the previous page's scroll position. Renders nothing.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
